import React, { useEffect, useState } from "react";
import "./All_Scales_Component.css";

import { Form, InputGroup } from "react-bootstrap";
import { Slider } from "@mui/material";

const All_Scales_Component = ({
  setInterestTotal,
  interestTotal,
  setEMITotal,
  EMITotal,
  setLoanValueTotal,
  loanValueTotal,
  setprincipalTotal,
  loanTenure,
  setLoanTenure,
  loanValue,
  setLoanValue,
  interestRate,
  setInterestRate,
  date,
  setYearlyBreakdown,
  //   yearlyBreakdown,
}) => {
  const [active, setActive] = useState("Monthly");
  //   setLoanTenure(240);
  //   setInterestRate(15);
  //   setLoanValue(100);
  const formatText = ({ valueText }) => `${valueText}L`;

  const loanmarks = [
    { value: 0, label: "0L" },
    { value: 25, label: "25L" },
    { value: 50, label: "50L" },
    { value: 75, label: "75L" },
    { value: 100, label: "100L" },
    { value: 125, label: "125L" },
    { value: 150, label: "150L" },
    { value: 175, label: "175L" },
    { value: 200, label: "200L" },
  ];

  const intresetmarks = [
    { value: 5, label: "5" },
    { value: 7.5, label: "7.5" },
    { value: 10, label: "10" },
    { value: 12.5, label: "12.5" },
    { value: 15, label: "15" },
    { value: 17.5, label: "17.5" },
    { value: 20, label: "20" },
  ];

  const tenuremarks = [
    { value: 0, label: "0" },
    { value: 60, label: "60" },
    { value: 120, label: "120" },
    { value: 180, label: "180" },
    { value: 240, label: "240" },
    { value: 300, label: "300" },
    { value: 360, label: "360" },
  ];
  const tenuremarksYear = [
    { value: 0, label: "0" },
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 15, label: "15" },
    { value: 20, label: "20" },
    { value: 25, label: "25" },
    { value: 30, label: "30" },
  ];

  // Convert values to proper format
  // const loanAmount = loanValue * 100000; // Convert Lacs to Rupees
  // const monthlyRate = interestRate / (12 * 100); // Convert Annual Rate to Monthly Decimal
  // const tenureMonths = active === "Yearly" ? loanTenure * 12 : loanTenure; // Convert Years to Months

  // let emi = 0;
  // let totalInterest = 0;
  // let totalPayment = 0;

  // // Avoid division by zero error
  // if (monthlyRate > 0 && tenureMonths > 0) {
  //   emi =
  //     (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, tenureMonths)) /
  //     (Math.pow(1 + monthlyRate, tenureMonths) - 1);

  //   totalInterest = emi * tenureMonths - loanAmount; // Total Interest Paid
  //   totalPayment = loanAmount + totalInterest; // Total Amount Paid
  // } else {
  //   emi = 0;
  //   totalInterest = 0;
  //   totalPayment = loanAmount; // If no interest, total payment is the principal amount
  // }

  // // Update state
  // setInterestTotal(Math.round(totalInterest));
  // setEMITotal(Math.round(emi));
  // setLoanValueTotal(Math.round(totalPayment));
  // setprincipalTotal(Math.round(loanAmount));

  const tenureYears =
    active === "Yearly" ? loanTenure : Math.ceil(loanTenure / 12); // Get total years

  // Avoid division by zero

  function calculateLoanBreakdown(loanAmount, annualRate, tenureMonths) {
    const monthlyRate = annualRate / (12 * 100);
    const tenureYears = Math.ceil(tenureMonths / 12);
    const emi =
      (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, tenureMonths)) /
      (Math.pow(1 + monthlyRate, tenureMonths) - 1);

    let remainingBalance = loanAmount;
    let cumulativePrincipalPaid = 0;

    let selectedDate = new Date(date);
    selectedDate.setFullYear(selectedDate.getFullYear() + 2); // Add 2 years

    let year = selectedDate.getFullYear();
    console.log(year, "year year date");
    let breakdown = [];

    for (let i = 0; i < tenureYears; i++) {
      let interestYearly = 0;
      let principalYearly = 0;

      for (let j = 0; j < 12; j++) {
        if (remainingBalance <= 0) break;

        let interestMonthly = remainingBalance * monthlyRate;
        let principalMonthly = emi - interestMonthly;

        interestYearly += interestMonthly;
        principalYearly += principalMonthly;
        remainingBalance -= principalMonthly;
      }

      cumulativePrincipalPaid += principalYearly;
      let percentagePaid = (cumulativePrincipalPaid / loanAmount) * 100;

      breakdown.push({
        year: year,
        interestPaid: Math.round(interestYearly),
        principalPaid: Math.round(principalYearly),
        totalPaid: Math.round(principalYearly + interestYearly),
        remainingBalance: Math.max(0, Math.round(remainingBalance)),
        percentagePaid: percentagePaid.toFixed(2) + "%",
      });

      year++;
      if (remainingBalance <= 0) break;
    }

    return breakdown;
  }

  // Example Usage
 

  // useEffect(() => {
  //   if (!loanValue || !interestRate || !loanTenure) return; // Prevent invalid values

  //   const loanAmount = loanValue * 100000; // Convert Lacs to Rupees
  //   const monthlyRate = interestRate / (12 * 100); // Convert Annual Rate to Monthly Decimal
  //   const tenureMonths = active === "Yearly" ? loanTenure * 12 : loanTenure; // Get total months
  //   const tenureYears = Math.ceil(tenureMonths / 12); // Get total years

  //   let emi = 0;
  //   let totalInterest = 0;
  //   let totalPayment = 0;
  //   let breakdown = []; // Store year-wise breakdown

  //   let selectedDate = new Date(date);
  //   selectedDate.setFullYear(selectedDate.getFullYear()); // Add 2 years

  //   let year = selectedDate.getFullYear();
  //   let remainingBalance = loanAmount;

  //   let cumulativePrincipalPaid = 0; // Track principal paid so far

  //   if (monthlyRate > 0 && tenureMonths > 0) {
  //     emi =
  //       (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, tenureMonths)) /
  //       (Math.pow(1 + monthlyRate, tenureMonths) - 1);

  //     totalInterest = emi * tenureMonths - loanAmount; // Total Interest Paid
  //     totalPayment = loanAmount + totalInterest; // Total Amount Paid

  //     // Yearly Breakdown Calculation
  //     for (let i = 0; i < tenureYears; i++) {
  //       let interestYearly = 0;
  //       let principalYearly = 0;

  //       // Process each month's EMI within the current year
  //       for (let j = 0; j < 12; j++) {
  //         if (remainingBalance <= 0) break;

  //         let interestMonthly = remainingBalance * monthlyRate;
  //         let principalMonthly = emi - interestMonthly;

  //         interestYearly += interestMonthly;
  //         principalYearly += principalMonthly;
  //         remainingBalance -= principalMonthly;
  //       }

  //       cumulativePrincipalPaid += principalYearly; // Track total principal paid
  //       let percentagePaid = (cumulativePrincipalPaid / loanAmount) * 100; // Calculate percentage paid

  //       breakdown.push({
  //         year: year,
  //         interestPaid: Math.round(interestYearly),
  //         principalPaid: Math.round(principalYearly),
  //         totalPaid: Math.round(principalYearly + interestYearly),
  //         remainingBalance: Math.max(0, Math.round(remainingBalance)), // Ensure no negative balance
  //         percentagePaid: percentagePaid.toFixed(2), // Percentage of loan paid off
  //       });

  //       year++; // Move to next year
  //       if (remainingBalance <= 0) break; // Stop when the loan is fully paid
  //     }
  //   } else {
  //     emi = 0;
  //     totalInterest = 0;
  //     totalPayment = loanAmount;
  //   }

  //   // Update state safely
  //   setInterestTotal(Math.round(totalInterest));
  //   setEMITotal(Math.round(emi));
  //   setLoanValueTotal(Math.round(totalPayment));
  //   setYearlyBreakdown(breakdown);
  //   setprincipalTotal(Math.round(loanAmount));
  // }, [loanValue, interestRate, loanTenure, date]);
  // Dependencies
  useEffect(() => {
    if (!loanValue || !interestRate || !loanTenure) return; // Prevent invalid values

    const loanAmount = loanValue * 100000; // Convert Lacs to Rupees
    const monthlyRate = interestRate / (12 * 100); // Convert Annual Rate to Monthly Decimal
    const tenureMonths = active === "Yearly" ? loanTenure * 12 : loanTenure; // Get total months
    const tenureYears = Math.ceil(tenureMonths / 12); // Get total years

    let emi = 0;
    let totalInterest = 0;
    let totalPayment = 0;
    let breakdown = []; // Store year-wise breakdown

    let selectedDate = new Date(date);
    let year = selectedDate.getFullYear();
    let startMonth = selectedDate.getMonth() + 1; // Get the starting month (1-12)
    let remainingBalance = loanAmount;

    let cumulativePrincipalPaid = 0; // Track principal paid so far
    let monthsRemaining = tenureMonths;

    if (monthlyRate > 0 && tenureMonths > 0) {
      emi =
        (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, tenureMonths)) /
        (Math.pow(1 + monthlyRate, tenureMonths) - 1);

      totalInterest = emi * tenureMonths - loanAmount; // Total Interest Paid
      totalPayment = loanAmount + totalInterest; // Total Amount Paid

      // Yearly Breakdown Calculation
      for (let i = 0; i < tenureYears+1; i++) {
        let interestYearly = 0;
        let principalYearly = 0;

        // Determine how many months to process in the current year
        let monthsInYear =
          i === 0 ? 12 - startMonth + 1 : Math.min(12, monthsRemaining);
        monthsRemaining -= monthsInYear; // Reduce months remaining in tenure

        // Process each month's EMI within the current year
        for (let j = 0; j < monthsInYear; j++) {
          if (remainingBalance <= 0) break;

          let interestMonthly = remainingBalance * monthlyRate;
          let principalMonthly = emi - interestMonthly;

          interestYearly += interestMonthly;
          principalYearly += principalMonthly;
          remainingBalance -= principalMonthly;
        }

        cumulativePrincipalPaid += principalYearly; // Track total principal paid
        let percentagePaid = (
          (cumulativePrincipalPaid / loanAmount) *
          100
        ).toFixed(2); // Percentage paid
        let percentageRemaining = (100 - percentagePaid).toFixed(2); // Remaining percentage

        breakdown.push({
          year: year,
          interestPaid: Math.round(interestYearly),
          principalPaid: Math.round(principalYearly),
          totalPaid: Math.round(principalYearly + interestYearly),
          remainingBalance: Math.max(0, Math.round(remainingBalance)), // Ensure no negative balance
          percentagePaid: `${percentagePaid}%`, // Percentage of loan paid off
          percentageRemaining: `${percentageRemaining}%`, // Percentage remaining
        });

        year++; // Move to next year
        if (remainingBalance <= 0) break; // Stop when the loan is fully paid
      }
    } else {
      emi = 0;
      totalInterest = 0;
      totalPayment = loanAmount;
    }

    // Update state safely
    setInterestTotal(Math.round(totalInterest));
    setEMITotal(Math.round(emi));
    setLoanValueTotal(Math.round(totalPayment));
    setYearlyBreakdown(breakdown);
    setprincipalTotal(Math.round(loanAmount));
  }, [loanValue, interestRate, loanTenure, date]);

  return (
    <div className="All_Scales_Component">
      <div className="home_loan_main_div scale_main_div">
        <div className="row">
          <div className="col-md-8 me-0 ms-0 p-0">
            <div className="scale_div">
              <div className="range_selector_container">
                <Slider
                  value={loanValue}
                  onChange={(_, newValue) => setLoanValue(newValue)}
                  step={25}
                  marks={loanmarks}
                  min={0}
                  max={200}
                  valueLabelDisplay="auto"
                />
              </div>
              <div className="scale_title_div">
                <p className="text">Home Loan Amount</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 custom_col me-0 ms-0 p-0">
            <div className="input_main_div">
              <InputGroup size="sm">
                <Form.Control
                  aria-label="Small"
                  type="number"
                  value={loanValue}
                  onChange={(e) => setLoanValue(Number(e.target.value))}
                  aria-describedby="inputGroup-sizing-sm"
                />
                <InputGroup.Text id="inputGroup-sizing-sm">
                  ₹{loanValue}L
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>
        </div>
      </div>

      <div className="home_loan_main_div scale_main_div">
        <div className="row">
          {/* Interest Rate Slider */}
          <div className="col-md-8 me-0 ms-0 p-0">
            <div className="scale_div">
              <div className="range_selector_container">
                <Slider
                  value={interestRate}
                  onChange={(_, newValue) => setInterestRate(newValue)}
                  step={0.5}
                  marks={intresetmarks}
                  min={5}
                  max={20}
                  valueLabelDisplay="auto"
                />
              </div>
              <div className="scale_title_div">
                <p className="text">Interest Rate</p>
              </div>
            </div>
          </div>

          {/* Interest Rate Input */}
          <div className="col-md-4 custom_col me-0 ms-0 p-0">
            <div className="input_main_div">
              <InputGroup size="sm">
                <Form.Control
                  aria-label="Small"
                  type="number"
                  value={interestRate}
                  onChange={(e) => setInterestRate(Number(e.target.value))}
                  aria-describedby="inputGroup-sizing-sm"
                />
                <InputGroup.Text id="inputGroup-sizing-sm">%</InputGroup.Text>
              </InputGroup>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="home_loan_main_div scale_main_div">
        <div className="row">
        
          <div className="col-md-8 me-0 ms-0 p-0">
            <div className="scale_div">
              <div className="range_selector_container">
                <Slider
                  value={loanTenure}
                  onChange={(_, newValue) => setLoanTenure(newValue)}
                  step={5}
                  marks={tenuremarks}
                  min={0}
                  max={30}
                  valueLabelDisplay="auto"
                />
              </div>
              <div className="scale_title_div">
                <p className="text">Loan Tenure</p>
              </div>
            </div>
          </div>

          
          <div className="col-md-4 custom_col me-0 ms-0 p-0">
            <div className="input_main_div">
              <Form.Control
                aria-label="Small"
                className="loan_tenure_input"
                type="number"
                value={loanTenure}
                onChange={(e) => setLoanTenure(Number(e.target.value))}
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

         
            <div className="toggle-container">
              <div className="toggle-switch">
                <div
                  className={`toggle-active ${
                    active === "Yearly" ? "shift-right" : ""
                  }`}
                ></div>
                <button
                  className={`toggle-btn ${
                    active === "Monthly" ? "selected" : ""
                  }`}
                  onClick={() => setActive("Monthly")}
                >
                  Mo
                </button>
                <button
                  className={`toggle-btn ${
                    active === "Yearly" ? "selected" : ""
                  }`}
                  onClick={() => setActive("Yearly")}
                >
                  Yr
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="home_loan_main_div scale_main_div">
        <div className="row">
          <div className="col-md-8 me-0 ms-0 p-0">
            <div className="scale_div">
              <div className="range_selector_container">
                <Slider
                  value={loanValue}
                  onChange={(_, newValue) => setLoanValue(newValue)}
                  step={2.5}
                  marks={intresetmarks}
                  min={5}
                  max={20}
                  valueLabelDisplay="auto"
                />
              </div>

              <div className="scale_title_div">
                <p className="text">Interest Rate</p>
              </div>
            </div>
          </div>

          <div className="col-md-4  custom_col  me-0 ms-0 p-0">
            <div className="input_main_div">
              <InputGroup size="sm">
                <Form.Control
                  aria-label="Small"
                  type="type"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <InputGroup.Text id="inputGroup-sizing-sm">%</InputGroup.Text>
              </InputGroup>
            </div>
          </div>
        </div>
      </div>*/}

      <div className="home_loan_main_div scale_main_div">
        <div className="row">
          <div className="col-md-8 me-0 ms-0 p-0">
            <div className="scale_div">
              <div className="range_selector_container">
                <Slider
                  value={loanTenure}
                  onChange={(_, newValue) => setLoanTenure(newValue)}
                  step={5}
                  marks={active === "Yearly" ? tenuremarksYear : tenuremarks}
                  min={0}
                  //   max={30}
                  max={active === "Yearly" ? 30 : 360}
                  valueLabelDisplay="auto"
                />
              </div>

              <div className="scale_title_div">
                <p className="text">Loan Tenure</p>
              </div>
            </div>
          </div>

          <div className="col-md-4  custom_col  me-0 ms-0 p-0">
            <div className="input_main_div">
              <div>
                <Form.Control
                  aria-label="Small"
                  className="loan_tenure_input"
                  type="type"
                  aria-describedby="inputGroup-sizing-sm"
                  value={loanTenure}
                  onChange={(e) => setLoanTenure(Number(e.target.value))}
                />
              </div>

              <div className="toggle-container">
                <div className="toggle-switch">
                  <div
                    className={`toggle-active ${
                      active === "Yearly" ? "shift-right" : ""
                    }`}
                  ></div>
                  <button
                    // className={`toggle-btn ${
                    //   active === "Monthly" ? "selected" : ""
                    // }`}
                    // onClick={() => setActive("Monthly")}
                    className={`toggle-btn ${
                      active === "Monthly" ? "selected" : ""
                    }`}
                    onClick={() => {
                      if (active === "Yearly") {
                        setLoanTenure(loanTenure * 12); // Convert years to months
                      }
                      setActive("Monthly");
                    }}
                  >
                    Mo
                  </button>
                  <button
                    // className={`toggle-btn ${
                    //   active === "Yearly" ? "selected" : ""
                    // }`}
                    // onClick={() => setActive("Yearly")}
                    className={`toggle-btn ${
                      active === "Yearly" ? "selected" : ""
                    }`}
                    onClick={() => {
                      if (active === "Monthly") {
                        setLoanTenure(Math.round(loanTenure / 12)); // Convert months to years
                      }
                      setActive("Yearly");
                    }}
                  >
                    Yr
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default All_Scales_Component;
